<template>
  <div>

    <button type="button" class="btn btn-blue-facebook btn-block mb-3 btn-social" @click="$emit('social', 'facebook', 'register')">
      <facebook-icon /> Cadastre-se com Facebook
    </button>
    <button type="button" class="btn btn-blue-linkedin btn-block mb-3 btn-social" @click="$emit('social', 'linkedin', 'register')">
      <linkedin-box-icon /> Cadastre-se com Linkedin
    </button>
    <button type="button" class="btn btn-cyan-dark text-white btn-block btn-social" @click="$emit('changeModal', 'register')">
      <email-icon /> Cadastre-se com E-mail
    </button>

    <div class="my-4">
      <hr>
    </div>

    <p class="text-center h6 font-weight-normal mb-3">Já tem uma conta do TotalPass Carreiras?</p>

    <button type="button" class="btn btn-blue-ml d-block mx-auto" @click="$emit('changeModal', 'login')">Entrar</button>

  </div>
</template>

<script>
  import FacebookIcon from "vue-material-design-icons/Facebook.vue"
  import LinkedinBoxIcon from "vue-material-design-icons/LinkedinBox.vue"
  import EmailIcon from "vue-material-design-icons/Email.vue"

  export default {
    name: 'DefineMethod',

    components: {
      FacebookIcon,
      LinkedinBoxIcon,
      EmailIcon
    }
  }
</script>

<style lang="scss" scoped>
  .btn{
    min-width: 170px;
  }
</style>